(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meb-mega-header"] && !Shopify.designMode) return;
  try {
    
  class MebMegaHeader extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-mmh-panel-item]'));
      this.drawer = this.querySelector('[data-mmh-drawer]');
      this.scrim = this.querySelector('[data-mmh-scrim]');
      this.openBtn = this.querySelector('[data-mmh-drawer-open]');
      this.closeBtn = this.querySelector('[data-mmh-drawer-close]');
      this.hoverTimers = new WeakMap();
      this.lastFocused = null;

      for (const item of this.panels) {
        const toggle = item.querySelector('[data-mmh-panel-toggle]');
        const panel = item.querySelector('[data-mmh-panel]');
        if (!toggle || !panel) continue;

        toggle.addEventListener('click', () => {
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          this.#closeAllPanels();
          if (!isOpen) this.#openPanel(toggle, panel);
        });

        item.addEventListener('mouseenter', () => {
          if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
          window.clearTimeout(this.hoverTimers.get(item));
          this.hoverTimers.set(item, window.setTimeout(() => { this.#closeAllPanels(); this.#openPanel(toggle, panel); }, 60));
        });
        item.addEventListener('mouseleave', () => {
          if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
          window.clearTimeout(this.hoverTimers.get(item));
          this.hoverTimers.set(item, window.setTimeout(() => this.#closePanel(toggle, panel), 180));
        });
      }

      this.openBtn?.addEventListener('click', () => this.#openDrawer());
      this.closeBtn?.addEventListener('click', () => this.#closeDrawer());
      this.scrim?.addEventListener('click', () => this.#closeDrawer());

      this.onDocClick = (event) => { if (!this.contains(event.target)) this.#closeAllPanels(); };
      document.addEventListener('click', this.onDocClick);

      this.onKeydown = (event) => {
        if (event.key === 'Escape') {
          this.#closeAllPanels();
          if (this.drawer && !this.drawer.hidden) this.#closeDrawer();
        }
        if (event.key === 'Tab' && this.drawer && !this.drawer.hidden) this.#trapFocus(event);
      };
      document.addEventListener('keydown', this.onKeydown);

      this.onScroll = () => {
        const scrolled = window.scrollY > 24;
        this.classList.toggle('mmh--solid', scrolled);
        this.classList.toggle('mmh--scrolled', scrolled);
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('scroll', this.onScroll);
      document.body.style.overflow = '';
    }

    #openPanel(toggle, panel) { toggle.setAttribute('aria-expanded', 'true'); panel.hidden = false; }
    #closePanel(toggle, panel) { toggle.setAttribute('aria-expanded', 'false'); panel.hidden = true; }
    #closeAllPanels() {
      for (const item of this.panels) {
        const toggle = item.querySelector('[data-mmh-panel-toggle]');
        const panel = item.querySelector('[data-mmh-panel]');
        if (toggle && panel) this.#closePanel(toggle, panel);
      }
    }

    #openDrawer() {
      if (!this.drawer) return;
      this.lastFocused = document.activeElement;
      this.drawer.hidden = false;
      this.scrim.hidden = false;
      requestAnimationFrame(() => this.drawer.classList.add('is-open'));
      this.openBtn?.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      this.closeBtn?.focus();
    }

    #closeDrawer() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.openBtn?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      window.setTimeout(() => { this.drawer.hidden = true; this.scrim.hidden = true; }, 280);
      if (this.lastFocused) this.lastFocused.focus();
    }

    #trapFocus(event) {
      const focusables = this.drawer.querySelectorAll('a[href], button:not([disabled]), summary, input, [tabindex]:not([tabindex="-1"])');
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  }

  if (!customElements.get('meb-mega-header')) {
    customElements.define('meb-mega-header', MebMegaHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
